<!-- @format -->

<template>
	<pcp-selector-dialog
		:value="selectedValue"
		:visible="selectorVisible"
		title="用户组选择器"
		width="60%"
		margin-top="15vh"
		:multiple="multiple"
		@input-main="(value) => (selectedValue = value)"
		@fullscreen="handleFullscreen"
		@remove-select="setSelectRow"
		@close="handleClose"
		@action-event="handleActionEvent"
	>
		<template #default="scope">
			<pcp-selector-panel
				ref="panel"
				v-bind="scope"
				:height="actualHeight"
				@selected="(value) => (selectedValue = value)"
			/>
		</template>
	</pcp-selector-dialog>
</template>
<script>
	import PcpSelectorPanel from './panel';
	import PcpSelectorDialog from '@/p-components/pcp-selector-dialog/dialog';

	export default {
		components: {
			PcpSelectorDialog,
			PcpSelectorPanel,
		},
		props: {
			visible: Boolean, // 是否可见
			title: {
				// 标题
				type: String,
				default() {
					return '用户组选择器';
				},
			},
			marginTop: {
				// Dialog CSS 中的 margin-top 值
				type: String,
				default: '15vh',
			},
			width: {
				// 宽
				type: String,
				default: '60%',
			},
			height: {
				// 高
				type: String,
				default: '345px',
			},
			closeOnClickModal: {
				// 是否可以通过点击 modal 关闭 Dialog
				type: Boolean,
				default: false,
			},
			closeOnPressEscape: {
				// 是否可以通过按下 ESC 关闭 Dialog
				type: Boolean,
				default: false,
			},
			showClose: {
				// 是否显示关闭按钮
				type: Boolean,
				default: true,
			},
			beforeClose: {
				// 关闭前的回调，会暂停 Dialog 的关闭
				type: Function,
			},
			fullscreen: {
				// 是否为全屏 Dialog
				type: Boolean,
				default: false,
			},
			labelKey: {
				// 展示的值
				type: String,
				default: 'name',
			},
			value: {
				type: [Object, Array],
				default: () => {
					return this && this.multiple ? [] : {};
				},
			},
			cleanClose: {
				// 按钮清空并关闭
				type: Boolean,
				default: false,
			},
			buttons: {
				// 按钮组
				type: Array,
			},
			confirmButtonText: {
				type: String,
				default() {
					return '确认';
				},
			},
			cleanButtonText: String,
			cancelButtonText: String,
			multiple: {
				// 是否多选
				type: Boolean,
				default: false,
			},
		},
		data() {
			return {
				selectorVisible: false,
				selectedValue: this.multiple ? [] : {},
				dialogFullscreen: this.fullscreen,
			};
		},
		computed: {
			actualHeight() {
				return this.dialogFullscreen ? this.getFullscreenDialogHeight() : this.height;
			},
		},
		watch: {
			visible: {
				handler() {
					this.selectorVisible = this.visible;
				},
				immediate: true,
			},
			value() {
				this.selectedValue = this.value;
			},
			fullscreen(val) {
				this.dialogFullscreen = val;
			},
		},
		beforeUnmount() {
			this.selectedValue = null;
		},
		methods: {
			getFullscreenDialogHeight() {
				const h = document.documentElement.clientHeight || document.body.clientHeight;
				return `${h - 60 - 90}px`;
			},
			setSelectRow() {
				this.$refs.panel.setSelectRow();
			},
			handleFullscreen(val) {
				this.dialogFullscreen = val;
			},
			handleClose(visible) {
				this.$emit('close', visible);
			},
			handleActionEvent(key) {
				if (key === 'clean') {
					this.setSelectRow();
				}
				// 备注：注释掉是因为外部回调事件会走两次
				// this.$emit('action-event', key, data);
			},
		},
	};
</script>
